/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Usage_SubtitleInputs */



/**
* | output |
* | --- |
* | "Provider, model, and token split for the current period." |
*
* @param {Partner_Dashboard_Usage_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_usage_subtitle = /** @type {((inputs?: Partner_Dashboard_Usage_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Usage_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anbieter, Modell und Token-Verteilung im aktuellen Zeitraum.")
	return /** @type {LocalizedString} */ ("Provider, model, and token split for the current period.")
});